import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';

import { BodyWrapper as _BodyWrapper } from '../style';

export const ImageWrapper = styled.div(() =>
  mq({
    position: 'relative',
    width: '100%',
    paddingTop: '31.25%',
  }),
);

export const BodyWrapper = styled(_BodyWrapper)(() =>
  mq({
    '& > span > span:nth-of-type(3n)': {
      marginBottom: '40px',
    },
  }),
);
